<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="接口id" prop="apiId">
            <el-select
              v-model="formData.apiId"
              clearable
              filterable
              size="small"
              style="width:100%"
              @change="changeApiId"
            >
              <el-option
                v-for="item in apiIdList"
                :key="item.value.apiId"
                :label="item.label"
                :value="item.value.apiId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="接口路径" prop="path">
            <el-input
              v-model="formData.path"
              clearable
              placeholder="请输入接口路径"
              size="small"
              maxlength="500"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="接口host" prop="host">
            <el-input
              v-model="formData.host"
              clearable
              placeholder="请输入接口host"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyTime ? formData.modifyTime : '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    appKey: { type: String, default: '' },
    clientPushApiCode: { type: String, default: '' },
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: { path: '' },
      rules: {
        apiId: [
          {
            required: true,
            message: '请选择接口Id',
            trigger: 'change',
          },
        ],
        path: [
          {
            required: true,
            message: '请输入接口路径',
            trigger: 'blur',
          },
        ],
        host: [
          {
            required: false,
            message: '请输入格式正确的域名',
            pattern: /(\w+):\/\/([^/:]+)(:\d*)?/,
          },
        ],
      },
      apiIdList: [
        {
          value: { path: '/v1/order/createAndSyncGoodsCofirm', apiId: '1-1' },
          label: '创建并同步数据',
        },
        {
          value: { path: '/v1/order/pod/receive', apiId: '1-2' },
          label: '接收数据',
        },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.apiIdList.map((o) => [o.value.apiId, o]))
    },
  },
  methods: {
    getData() {
      if (!this.clientPushApiCode) return

      this.$api
        .sysOpenapiClientPushapiDetailApi({
          clientPushApiCode: this.clientPushApiCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .sysOpenapiClientPushapiSaveApi({
          ...this.formData,
          appKey: this.appKey,
        })
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm('是否要保存更改', '提示信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '保存',
        cancelButtonText: '不保存',
      })
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },

    changeApiId(val) {
      if (val) {
        this.formData.path = this.optionsMap[val]
          ? this.optionsMap[val].value.path
          : ''
      } else {
        this.formData.path = ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
